import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getEmployeeDepartments,
  getEmployeeDepartment,
  createEmployeeDepartment,
  editEmployeeDepartment,
  deleteEmployeeDepartment,
  getAllEmployeeDepartments,
  getTrashedEmployeeDepartments,
  restoreEmployeeDepartment,
} from "api/employeeDepartmentApi"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const EMPLOYEE_DEPARTMENT_QUERY_KEY = "employee-departments"

export const useEmployeeDepartments = (params = {}, enabled = true) => {
  return usePaginatedResource(
    EMPLOYEE_DEPARTMENT_QUERY_KEY,
    getEmployeeDepartments,
    params,
    enabled
  )
}

export const useEmployeeDepartment = (id, enabled = true) => {
  return useResourceItem(
    EMPLOYEE_DEPARTMENT_QUERY_KEY,
    getEmployeeDepartment,
    id,
    enabled
  )
}

export const useCreateEmployeeDepartment = () => {
  return useCreateResource(
    createEmployeeDepartment,
    EMPLOYEE_DEPARTMENT_QUERY_KEY
  )
}

export const useEditEmployeeDepartment = () => {
  return useEditResource(
    editEmployeeDepartment,
    EMPLOYEE_DEPARTMENT_QUERY_KEY
  )
}

export const useDeleteEmployeeDepartment = () => {
  return useDeleteResource(
    deleteEmployeeDepartment,
    EMPLOYEE_DEPARTMENT_QUERY_KEY
  )
}

export const useAllEmployeeDepartments = (params = {}) => {
  return usePaginatedResource(
    EMPLOYEE_DEPARTMENT_QUERY_KEY,
    getAllEmployeeDepartments,
    { ...params, all: true },
    true
  )
}

export const useTrashedEmployeeDepartments = (params = {}) => {
  return usePaginatedResource(
    EMPLOYEE_DEPARTMENT_QUERY_KEY,
    getTrashedEmployeeDepartments,
    params,
    true
  )
}

export const useRestoreEmployeeDepartment = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restoreEmployeeDepartment,
    onSuccess: (res, { id }) => {
      const restoredItem = res?.data
      if (!restoredItem) return

      queryClient.setQueriesData([EMPLOYEE_DEPARTMENT_QUERY_KEY, "all"], old => {
        if (!old || !old.data || !Array.isArray(old.data.data)) return old
        const updated = structuredClone(old)
        updated.data.data = [restoredItem, ...updated.data.data]
        updated.data.total = (updated.data.total || 0) + 1
        return updated
      })

      queryClient.setQueryData([EMPLOYEE_DEPARTMENT_QUERY_KEY, id], restoredItem)
    },
  })
}
